import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";

const ShortCodeMatcheCreate = ()=>{
     const [shortCode, setShortCode ] = useState('');
     const [user, setUser ] = useState('');
     const [users, setUsers] = useState([]);
     const [redirect, setRedirect] = useState(false);
     const[page,setPage] = useState(1);
     const[errorMessage, setErrorMessage] = useState('');
     const[loading,setLoading] = useState(false);
     const[hasError, setHasError] = useState(false);

     useEffect(() => {
        const fetchUsers = async () => {
          setLoading(true);
          setHasError(false);
          setErrorMessage('');
    
          try {
            const { data } = await axios.get(`users?page=${page}`);
            console.log(data);
            setUsers(data.data);
           // setLastPage(data.meta.last_page);
          } catch (error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              if (error.response.status === 401) {
                setErrorMessage("Unauthorized access.");
              } else if (error.response.status === 400) {
                setErrorMessage("Bad request. Please check your input.");
              }
              else if (error.response.status === 500) {
                setErrorMessage("Insufficient Permissions");
              }
              else {
                setErrorMessage("An error occurred. Please try again later.");
              }
            } else if (error.request) {
              // The request was made but no response was received
              if (error.message === "Network Error") {
                setErrorMessage("Failed to connect to the server. Please try again later.");
              } else {
                setErrorMessage("No response received. Please try again later.");
              }
            } else {
              // Something happened in setting up the request that triggered an Error
              setErrorMessage("An error occurred. Please try again later.");
            }
            setHasError(true);
          } finally {
            setLoading(false);
          }
        };
    
        fetchUsers();
      }, [page]);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('shortCodeMatch', {
            short_code:shortCode,
            user_id:parseInt(user),
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/shortCodeMatches'} />
    }
     return (
         <Wrapper pageTitle={"New ShortCodeMatche"}>
            <InnerNav createLink={'/shortCodeMatcheCreate'} listLink={'/shortCodeMatches'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ShortCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ShortCode"
                        onChange = {e => setShortCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">User </span>
                        <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="senderId"
                        onChange = {e => setUser(e.target.value)} >
                            <option key='0' value='0' >Choose User</option>

                        {users.map((user)=>{
                                        return(
                                            <option key={user.id} value={user.id} >
                                            {user.first_name + " " + user.last_name + " " + user.email} 
                                            </option>
                                        );
                                    })
                                }

                    </select>
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default ShortCodeMatcheCreate;